import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type DocumentoPrincipalStylesType = {
  wrapper: SxProps
  switch: SxProps
  requiredField: SxProps
}

export const documentoPrincipalStyles: DocumentoPrincipalStylesType = {
  wrapper: {
    marginBottom: theme.spacing(1.5)
  },

  switch: {
    margin: 0
  },

  requiredField: {
    display: 'block',
    color: theme.colors.red01,
    fontFamily: theme.corporate.primaryFont,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    margin: '16px 0',

    '&:before': {
      position: 'relative',
      content: '"*"',
      fontFamily: theme.corporate.primaryFont,
      fontSize: '18px',
      color: theme.colors.red01
    }
  }
}
